<template>
  <div class="xh-esg-index">
    <div class="top">
      <div class="topbanner">
        <div class="bannerL">
          <div class="namebox overFlowHidenTitle">{{ this.fullname }}</div>

          <div class="codebox overFlowHidenTop">
            {{ this.detailsData.company_short_name }}：{{
              this.detailsData.stock_code
            }}
          </div>

          <div class="industrybox" :title="this.detailsData.secondary_industry">
            &nbsp;&nbsp; {{ this.detailsData.secondary_industry }} &nbsp;
          </div>
        </div>
        <div class="bannerM">
          <div class="updown">
            <img
              v-if="this.detailsData.diff > 0"
              src="../../assets/white_theme/esg-sj-up.png"
              alt=""
            />
            <img
              v-if="this.detailsData.diff < 0"
              src="../../assets/white_theme/esg-sj-down.png"
              alt=""
            />
            <img
              class="equal"
              v-if="this.detailsData.diff == 0"
              src="../../assets/white_theme/esg-sj-equal.png"
              alt=""
            />
          </div>
          <div class="sumrank">{{ this.detailsData.score }}</div>
          <div class="sumranks">总评分</div>
          <div class="sumday">{{ this.detailsData.record_time }}</div>
        </div>
        <div class="bannerMM">
          <div class="bannerMMTop">
            <div class="arank best" v-if="this.topAllCompanyLevel == 1">
              <span class="iconfont">优秀</span>
            </div>
            <div class="arank better" v-if="this.topAllCompanyLevel == 2">
              <span class="iconfont">一般</span>
            </div>
            <div class="arank good" v-if="this.topAllCompanyLevel == 3">
              <span class="iconfont">良好</span>
            </div>
            <div class="arank bad" v-if="this.topAllCompanyLevel == 4">
              <span class="iconfont">较差</span>
            </div>

            <div
              class="dustryrank best"
              v-if="this.topIndustryCompanyLevel == 1"
            >
              <span class="iconfont">优秀</span>
            </div>
            <div
              class="dustryrank better"
              v-if="this.topIndustryCompanyLevel == 2"
            >
              <span class="iconfont">一般</span>
            </div>
            <div
              class="dustryrank good"
              v-if="this.topIndustryCompanyLevel == 3"
            >
              <span class="iconfont">良好</span>
            </div>
            <div
              class="dustryrank bad"
              v-if="this.topIndustryCompanyLevel == 4"
            >
              <span class="iconfont">较差</span>
            </div>
          </div>
          <div class="bannerMMBottom">
            <div class="arankt">A股排名</div>
            <div class="industryt">行业排名</div>
          </div>
        </div>
        <div class="bannerR" v-if="this.detailsData.stock_code == '601318.SH'">
          <div class="rectangle" @click="checkcard()">
            <div class="checkcard"></div>
            <span style="margin-left: 10px">查看企业名片</span>
          </div>
        </div>
      </div>
      <div class="tab">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="环境" name="E">
            <div class="tabbox" v-if="activeName == 'E'">
              <tabbox :activeName="activeName" :detailsData="detailsData">
              </tabbox>
            </div>
          </el-tab-pane>
          <el-tab-pane label="社会" name="S">
            <div class="tabbox" v-if="activeName == 'S'">
              <tabbox :activeName="activeName" :detailsData="detailsData">
              </tabbox>
            </div>
          </el-tab-pane>
          <el-tab-pane label="治理" name="G">
            <div class="tabbox" v-if="activeName == 'G'">
              <tabbox :activeName="activeName" :detailsData="detailsData">
              </tabbox>
            </div>
          </el-tab-pane>
          <el-tab-pane label="业务" name="B">
            <div class="tabbox" v-if="activeName == 'B'">
              <tabbox :activeName="activeName" :detailsData="detailsData">
              </tabbox>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="down">
      <div class="downbox">
        <div class="iconline">
          <span class="icon"
            ><img src="../../assets/white_theme/esg-sj-icon.png" /></span
          ><b style="color: var(--font_01);">同行业&同地区比较总评分</b>
        </div>
        <div class="tboxtitle downtitle">
          <div class="ttitle rtitle">
            <div class="circle"></div>
            <span class="circlef">同行业比较</span>
          </div>
          <div class="ttitle">
            <div class="circle"></div>
            <span class="circlef">同地区比较</span>
          </div>
        </div>
        <div class="downbigbox">
          <div class="downonebox">
            <div class="downonechart" style="height: 223px; width: 450px">
              <lineOnechart
                :params="downoneparams"
                :url="downoneurl"
              ></lineOnechart>
            </div>
          </div>
          <div class="downtwobox">
            <div class="downtwochart" style="height: 223px; width: 450px">
              <lineOnechart
                :params="downtwoparams"
                :url="downtwourl"
              ></lineOnechart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import lineOnechart from "./e4lineOne.vue";
import tabbox from "./tabbox.vue";
export default {
  data() {
    return {
      activeName: "E",
      detailsData: {},
      fullname: "",
      topAllCompanyLevel: "",
      topIndustryCompanyLevel: "",
      tabData: {},
      barurl: "",
      barparams: {},
      radarurl: "",
      radarparams: {},
      lineoneurl: "",
      lineoneparams: {},
      linetwourl: "",
      linetwoparams: {},
      downoneurl: "",
      downoneparams: {},
      downtwourl: "",
      downtwoparams: {},
    };
  },
  created() {
    this.detailsData = this.$route.query;
  },
  mounted() {
    this.downoneurl = "/esg/data/score_cp_line_industry";
    this.downoneparams = {
      type: "A",
      seCode: this.detailsData.stock_code,
    };
    this.downtwourl = "/esg/data/score_cp_line_region";
    this.downtwoparams = {
      type: "A",
      seCode: this.detailsData.stock_code,
    };
    this.getTopAllCompanyLevel();
    this.getTopIndustryCompanyLevel();
    this.getFullName();
  },
  methods: {
    ...mapActions("dataInfo/index", {
      company_full_name: "company_full_name",
      company_level: "company_level",
    }),
    getFullName() {
      let _this = this;
      let params = { seCode: this.detailsData.stock_code };
      this.company_full_name(params).then((res) => {
        _this.fullname = res;
      });
    },
    getTopAllCompanyLevel() {
      var _this = this;
      let params = {
        type: "",
        seCode: this.detailsData.stock_code,
        dateStr: this.detailsData.record_time,
        isAll: "0",
      };

      this.company_level(params).then((res) => {
        _this.topAllCompanyLevel = res;
      });
    },
    getTopIndustryCompanyLevel() {
      var _this = this;
      let params = {
        type: "",
        seCode: this.detailsData.stock_code,
        dateStr: this.detailsData.record_time,
        isAll: "1",
      };

      this.company_level(params).then((res) => {
        _this.topIndustryCompanyLevel = res;
      });
    },
    handleClick(tab, event) {},
    checkcard() {
      let params = {
        path: "/settledInfo/card",
      };
      this.$router.push(params);
    },
  },
  components: {
    lineOnechart,
    tabbox,
  },
};
</script>
<style lang="scss" scoped>
.xh-esg-index {
  width: 1100px;
  margin: 0 auto;
}
.top,
.bottom {
  background: var(--comp_06);
}
.top {
  margin-top: 40px;
  height: 890px;
  border: 1px solid var(--comp_06);
}
.bottom {
  margin-top: 15px;
  height: 500px;
}
.topbanner {
  width: 980px;
  margin: 24px 52px 0 50px;
  height: 90px;
}
.bannerL {
  width: 470px;
  height: 64px;
  float: left;
}
.namebox {
  width: 386px;
  height: 33px;
  font-size: 24px;
  float: left;
  font-weight: 550;
  color: var(--font_01);
}
.codebox {
  margin-top: 7px;
  font-size: 16px;
  width: 164px;
  height: 24px;
  float: left;
  color: var(--font_01);
}
.industrybox {
  float: left;
  min-width: 104px;
  height: 21px;
  margin: 6px 0 6px 15px;
  text-align: center;
  background: #008bce;
  color: #ffffff;
  line-height: 21px;
  font-size: 12px;
}
.bannerM {
  float: left;
  height: 74px;
  width: 160px;
  margin-left: 43px;
}
.sumrank {
  width: 132px;
  height: 46px;
  font-size: 48px;
  color: #1f1f1f;
  font-weight: 700;
  line-height: 40px;
  letter-spacing: -3px;
  text-align: center;
  color: var(--font_01);
}
.updown {
  position: relative;

  img {
    position: absolute;
    width: 16px;
    height: 20px;
    top: 10px;
    right: 5px;
  }
  .equal {
    width: 18px;
    height: 4px;
    top: 20px;
    right: 1px;
  }
}
.bannerR {
  float: right;
}
.rectangle {
  width: 125px;
  height: 35px;
  background: #008bce;
  border-radius: 4px;
  line-height: 35px;
  color: #ffffff;
  display: flex;
  margin-top: 25px;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.arank {
  width: 40px;
  height: 48px;
  border-radius: 4px;
  float: left;
  line-height: 48px;
  display: flex;
  margin-left: 3px;
}
.best {
  color: #90cc75;
  border: 1px solid #90cc75;
}
.better {
  color: #e2942b;
  border: 1px solid #e2942b;
}
.good {
  color: #008bce;
  border: 1px solid #008bce;
}
.bad {
  color: #fc4b4e;
  border: 1px solid #fc4b4e;
}
.dustryrank {
  width: 40px;
  height: 48px;
  border-radius: 4px;
  float: left;
  line-height: 48px;
  margin-left: 18px;
  display: flex;
}
.bannerMM {
  height: 100%;
  width: 142px;
  float: left;
}
.iconfont {
  margin: 0 auto;
}
.checkcard {
  line-height: 17px;
  background: url("../../assets/white_theme/esg-sj-mingpian.png");
  height: 17px;
  width: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.tab {
  height: 900px;
  width: 915px;
  // margin-left: 60px;
}
/deep/.el-tabs__nav-scroll {
  background: var(--xhcj-sj-tab_01);
}
/deep/ .el-tabs__item {
  color: var(--font_01);
}

.tablefttop {
  width: 148px;
  height: 45px;
  float: left;
}
.tabright {
  float: right;
  height: 51px;
  width: 535px;
  font-size: 12px;
  float: right;
}
.tableftupdown {
  height: 20px;
  width: 16px;
  background: url("../../assets/white_theme/esg-sj-down.png");
  float: left;
}
.tableft {
  width: 377px;
  height: 80px;
  float: left;
}
.everyranks {
  float: left;
}
.everysumday {
  float: left;
}
.tabbox {
  height: 700px;
  width: 975px;
  margin-left: 12px;
}
.tab {
  margin: 24px 52px 0 50px;
  width: 1000px;
  height: 1000px;
}
.tabrank {
  height: 30px;
  width: 125px;
  float: left;
}
.sumranks {
  font-size: 10px;
  float: left;
  margin-top: 10px;
  margin-left: 20px;
  color: var(--xhcj-sj-dc1f);
}
.sumday {
  font-size: 10px;
  float: left;
  margin-left: 12px;
  margin-top: 10px;
  color: #A1A7AF;
}
.bannerMM {
  margin-left: 40px;
}
.bannerMMTop {
  height: 58px;
  width: 100%;
}
.bannerMMBottom {
  height: 14px;
  width: 100%;
}
.arankt {
  width: 50px;
  height: 14px;
  font-size: 10px;
  float: left;
  margin-left: 2px;
  color: var(--xhcj-sj-dc1f);
}
.industryt {
  width: 50px;
  height: 14px;
  font-size: 10px;
  margin-left: 6px;
  float: left;
  color: var(--xhcj-sj-dc1f);
}
/deep/.el-tabs__nav {
  margin-left: 24px;
}

//超出部分变为点
.overFlowHidenTop {
  overflow: hidden;
  text-align: center;
  display: inline-block;
  // width: 350px;
  white-space: nowrap;
  text-overflow: ellipsis;
  // 注: overflow:hidden; 必写
  //宽度（width）必写
  //white-space:nowrap; //不换行
  //text-overflow:ellipsis;//超出部分变为点
}
//超出部分变为点
.overFlowHidenTitle {
  overflow: hidden;
  // text-align: center;
  display: inline-block;
  // width: 350px;
  white-space: nowrap;
  text-overflow: ellipsis;
  // 注: overflow:hidden; 必写
  //宽度（width）必写
  //white-space:nowrap; //不换行
  //text-overflow:ellipsis;//超出部分变为点
}
.bottomtop {
  display: flex;
  flex: 1;
  justify-content: space-between;
}

.down {
  width: 100%;
  height: 451px;
  background: var(--comp_06);
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon {
  margin-right: 13px;
  font-size: 16px;
}
.downbox {
  width: 100%;
  height: 366px;
  padding: 0 50px;
}
.iconline {
  height: 30px;
  margin-bottom: 30px;
  b {
    font-size: 16px;
  }
}
.circle {
  // float: left;
  z-index: 79;
  width: 10px;
  height: 10px;
  background-color: rgba(122, 213, 244, 1);
  border-radius: 50%;
  margin-right: 11px;
  font-size: 12px;
  display: inline-block;
  vertical-align: middle;
}

.downbigbox {
  display: flex;
  margin-left: 34px;
  justify-content: space-between;
}
.downonebox {
  flex: 1;
  height: 188px;
}
.downtwobox {
  flex: 1;
  height: 188px;
  margin-left: 70px;
}

.tboxtitle {
  display: flex;
  height: 30px;
  margin-top: 20px;
}
// .ttitle {
//   flex: 1;
// }

.downtitle {
  margin-left: 30px;
}
/deep/ .el-tabs__nav-wrap::after {
  height: 0;
}
/deep/ el-input__inner {
  font-size: 12px;
}
.rtitle {
  flex-basis: 520px;
}
.circlef {
  font-size: 12px;
  color: var(--font_01);
}
</style>
